
import { getInfos } from './CartProduct'

export default {
  name: 'CartExerptProduct',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    infos() {
      return getInfos(this.product)
    }
  }
}
